"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadcareLoader = void 0;
const UploadcareImage_1 = require("./components/UploadcareImage");
const loader_1 = require("./utils/loader");
Object.defineProperty(exports, "uploadcareLoader", { enumerable: true, get: function () { return loader_1.uploadcareLoader; } });
exports.default = UploadcareImage_1.UploadcareImage;
